import styled from 'styled-components'

export const StyledDescription = styled.details`
  summary {
    cursor: pointer;
  }
  div {
    margin-top: 0.5rem;
    margin-left: 0.75rem;
    svg {
      padding-right: 0.25rem;
    }
  }
`
export const InlineHelp = styled.div`
  margin-top: 2rem;
`
